var map = {
	"./labmemtest_logo_en.png": "1bc9",
	"./labmemtest_logo_jp.png": "e4e6",
	"./labmemtest_logo_kr.png": "75ea",
	"./labmemtest_logo_sc.png": "316b",
	"./labmemtest_logo_tc.png": "dc32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad6e";